<template>
  <div class="lp-border-controls">
    <button
        v-tooltip="option.tooltip"
        v-for="option in options"
        :key="option.id || option.name"
        :class="{ 'is-active': isActive(option.name) }"
        :disabled="disabled.indexOf(option.name) !== -1"
        type="button"
        class="lp-border-controls__tile"
        @click="$emit('select', option.name)">
      <icon :name="option.icon"/>
      <span>{{ option.label || shortLabel(option.name) }}</span>
    </button>
  </div>
</template>

<script>
const SHORT_LABELS = {
  'horizontal-inner': 'Horizontal',
  'vertical-inner':   'Vertical',
};

export default {
  name:  'BorderControls',
  props: {
    options:  { type: Array, required: true },
    value:    { type: [String, Array], default: null },
    disabled: { type: Array, default: () => [] },
  },
  methods: {
    isActive(name) {
      return Array.isArray(this.value) ? this.value.indexOf(name) !== -1 : this.value === name;
    },
    shortLabel(name) {
      const label = SHORT_LABELS[name] || name || '';
      return label.charAt(0).toUpperCase() + label.slice(1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/lp-tokens';

.lp-border-controls {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.lp-border-controls__tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 8px 4px;
  border: 1px solid transparent;
  border-radius: $lp-radius-tile;
  background: $lp-fill;
  font-family: $lp-sans;
  font-size: $lp-fs-label;
  color: $lp-ink-2;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: $lp-line;
  }

  &.is-active {
    border-color: $lp-accent;
    background: $lp-accent-soft;
    color: $lp-accent;
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  ::v-deep .icon {
    min-width: 0;
    min-height: 0;
  }
}
</style>
